export default __webpack_public_path__ + "static/media/tni-au-logo-white.2d2adc2b.png";